module.exports = __webpack_public_path__ + "static/media/iconBar.4a228ca3.svg";